<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AIC ONE - reset</title>
</head>

<body class="login-home background-body">
  <div class="container align-items-center d-flex">
      <!-- Logo Section -->
      <div class="logo-section">
        <img
          :src="styleConfig.reset_logo"
          alt="aicone Logo"
          class="logo"
        />

        <div class="user-count d-none               ">
          <div class="user-dots d-flex">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <span>3k+ people joined us, now it's your turn</span>
        </div>
      </div>

 <div class="sign-in-form">
    <div class="mt-3 mb-4">
      <h2 class="text-black fw-bold">Reset Password</h2>
      <p class="text-black">Enter your email address to receive a password reset link.</p>
    </div>

    <form @submit.prevent="submit_form">

      <div class="form-floating-custom">
          <input type="email" id="email" class="form-input" placeholder=" " v-model="form.email"/>
          <label class="form-label" for="email">Email Address</label>
        </div>
      <button
        type="submit"
        class="btn sign-up-btn btn-dark w-100 fw-bold mb-2"
        :disabled="loading"
      >
        <span v-if="loading">
          <i class="fas fa-spinner fa-spin me-2"></i> Sending...
        </span>
        <span v-else>
          Send Reset Link
        </span>
      </button>


      <div class="forgot-password mt-3 text-center">
        <span>
          Remember your password?
          <a href="/">Back to Login</a>
        </span>
      </div>
    </form>
  </div>
  </div>

</body>
